// React
import React from 'react';

// Material UI
import { Grid, Box } from '@material-ui/core';

// translations
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';
import PayRentInAdvance from './PayInAdvance';
import Before2019 from './Before2019';
import After2019 from './After2019';

// utils

// Styles
import ADGMPanel from '../ADGMPanel';
import styles from './styles';

function RentDetailsV2({ classes, isEditable = false, application }) {
  const { totalAmount } = application;

  const SHOW_BEFORE_2019_SECTION = !!application?.lateFeesBefore2019;
  const SHOW_AFTER_2019_SECTION = !!application?.lateFeesAfter2019;

  return (
    <ADGMPanel title={<FormattedMessage {...messages.rent_details} />}>
      <Grid container className={classes.container} spacing={2}>
        {SHOW_BEFORE_2019_SECTION && <Before2019 classes={classes} />}
        {SHOW_AFTER_2019_SECTION && <After2019 classes={classes} />}

        <PayRentInAdvance classes={classes} isEditable={isEditable} />
      </Grid>
      <Total {...{ classes, totalAmount }} />
    </ADGMPanel>
  );
}

function Total({ classes, totalAmount }) {
  return (
    <Box display='flex' alignItems='center' justifyContent='space-between' mt={2} className={classes.totalContainer}>
      <span>
        <FormattedMessage {...messages.total_to_be_paid} />
      </span>
      <span>{keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(totalAmount) })}</span>
    </Box>
  );
}

Total.propTypes = {
  classes: PropTypes.object.isRequired,
  totalAmount: PropTypes.number.isRequired,
};

RentDetailsV2.propTypes = {
  classes: PropTypes.object.isRequired,
  isEditable: PropTypes.bool,
  application: PropTypes.object.isRequired,
};

RentDetailsV2.defaultProps = {
  isEditable: false,
};

export default withStyles(styles)(RentDetailsV2);

// make the same action type for save and fetch
